module.exports = __webpack_public_path__ + "media/images/digivent/digivent-5931e5ad80e0cfc06fd6bf9e09ee5ee1.png";